import React, { useEffect, useState } from 'react';

const MainFeature = () => {
    const [choose, setChoose] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchChooseData = async () => {
            try {
                const response = await fetch('https://server.enjoywiki.com/hunt-crow/why-choose/');
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setChoose(data[0]); // Assuming the API returns an array with one object
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching choose data:', error);
                setError(error);
                setIsLoading(false);
            }
        };

        fetchChooseData();
    }, []);

    // If still loading, show a loading state
    if (isLoading) {
        return (
            <div className="software-benifits-area overflow-hidden default-padding">
                <div className="container">
                    <div className="text-center">Loading...</div>
                </div>
            </div>
        );
    }

    // If there's an error, show an error message
    if (error) {
        return (
            <div className="software-benifits-area overflow-hidden default-padding">
                <div className="container">
                    <div className="text-center text-danger">Error loading data</div>
                </div>
            </div>
        );
    }

    return (
        <div className="software-benifits-area overflow-hidden default-padding">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-lg-5">
                        <h4 className="sub-title">Find Your Targeted Clients</h4>
                        <h2 className="title mb-30 animation-text">
                        Reach Out Today and Offer Your Digital Marketing Services
                        </h2>
                        <p>On this platform, you'll discover eCommerce websites with low traffic, poor SEO scores, and businesses that urgently need digital marketing services to enhance their online presence and performance.</p>
                        <ul className="list-double mt-40">
                            <li className="animate" data-animate="fadeInUp">
                                <h5>Collect Contact Info</h5>
                                <p>You will get valid email addresses of eCommerce decision-makers.</p>
                            </li>
                            <li className="animate" data-animate="fadeInUp" data-delay="300ms">
                                <h5>Identify Major Issues</h5>
                                <p>On this platform, our system will show eCommerce website's accurate performance.</p>
                            </li>
                            <li className="animate" data-animate="fadeInUp" data-delay="600ms">
                                <h5>Start Email Marketing</h5>
                                <p>Create targeted email campaigns to engage and convert leads.</p>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-6 offset-lg-1 col-xl-5 offset-xl-1">
                        <div className="soft-illustration">
                            <img
                                src='https://i.postimg.cc/gcNtHD2S/Digital-Marketing.jpg'
                                alt="Software Illustration"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "/assets/img/illustration/14.png";
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainFeature;